import React, { useEffect, useState } from "react";
import DatePicker from "react-date-picker";
import { Calendar, ChevronDown, X } from "react-feather";
import Modal from "react-modal";
import { createGlobalStyle } from "styled-components";
import { useCartorio } from "../../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
import { useFuncionarioPrefeitura } from "../../../../Hooks/funcionarioPrefeitura";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";
import { IImovelFocus } from "../../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import api from "../../../../Services/api";
import { helpNumber } from "../../../../Services/helpNumber";
import theme from "../../../../Styles/theme";
import { Alert } from "../../../Error/Alert";
import { ModalDivX } from "../../../ModalDivX";
import { ModalLoader } from "../../../ModalLoader";
import {
  ITipoNaoTributado,
  ModalTipoNaoTributado,
} from "./ModalTipoNaoTributado";
import CurrencyInput from "react-currency-input-field";

import {
  Button,
  Container,
  ContainertInput,
  HelperCentralize,
  Input,
  Label,
  LabelRadioButton,
  Section,
  SectionTitle,
  Textarea,
  TipoNaoTributadoButton,
} from "./styles";
import { isRural } from "../../../../Utils/isRural";
import { TextField } from "@mui/material";
import { InputMoeda } from "./InputMoeda";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  imovel: IImovelFocus;
  handleSetImovel(im: IImovelFocus): void;
}

const DatePickerWrapperStyles = createGlobalStyle`
  .formata-date-picker {
      background-color: ${theme.colors.light};
      border:none;
      border-radius:0.25rem;
      color:${theme.colors.dark};
     font-size: calc(0.4vw + 8px);
    width:100%;
  }
`;
export function ModalAvaliacao({
  open,
  onClose,
  imovel,
  handleSetImovel,
}: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
  const { prefeituraIsLogged, checarTokenPrefeitura } = usePrefeitura();
  const {
    funcionarioPrefeituraIsLogged,
    FuncionarioPrefeitura,
    checarTokenFuncionarioPrefeitura,
  } = useFuncionarioPrefeitura();
  const { cartorioIsLogged, cartorio, checarToken } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();

  const [valorTerrCart, setvalorTerrCart] = useState(0);
  const [valorBenfCart, setvalorBenfCart] = useState(0);

  const [valorTerrPref, setvalorTerrPref] = useState(0);
  const [valorBenfPref, setvalorBenfPref] = useState(0);
  const [aliquota, setAliquota] = useState(2);
  const [aliquota2, setAliquota2] = useState(2);
  const [entrada, setEntrada] = useState(0);
  const [vencimento, setVenc] = useState(null as Date | null);
  const [tributado, setTributado] = useState(true);
  const [modalTipoTributacao, setmodalTipoTributacao] = useState(false);
  const [tipoNaoTributado, setTipoNaoTributado] = useState(
    {} as ITipoNaoTributado
  );
  const [baseLegal, setBaseLegal] = useState("");
  const [testeValor, setTesteValor] = useState("");
  const [parte1, setParte1] = useState(0);

  useEffect(() => {
    setParte1(0);
  }, [open]);

  const limparNumeroComVirgula = (valor: string) => {
    valor = valor.replace(/[^\d,]/g, ''); // remove tudo que não for número ou vírgula
    const partes = valor.split(',');
    if (partes.length > 2) {
      valor = partes[0] + ',' + partes[1]; // impede mais de uma vírgula
    }
    return valor;
  };


  useEffect(() => {
    if (
      imovel.TIPO_TRIBUTACAO &&
      imovel.CLASSE_NAO_TRIBUTADO &&
      imovel.OBS_NAO_TRIBUTADO
    ) {
      setTipoNaoTributado({
        TITULO: imovel.CLASSE_NAO_TRIBUTADO,
        ID: imovel.TIPO_TRIBUTACAO,
      });
      setBaseLegal(imovel.OBS_NAO_TRIBUTADO);
      setTributado(false);
    }

    if (imovel.ALIQUOTA) {
      setAliquota(imovel.ALIQUOTA);
    }
    if (imovel.ALIQUOTA2) {
      setAliquota2(imovel.ALIQUOTA2);
    }

    if (imovel.VALOR_CARTORIO_BENFEITORIAS) {
      setvalorBenfCart(imovel.VALOR_CARTORIO_BENFEITORIAS);
    }

    if (imovel.VALOR_CARTORIO_TERRENO) {
      setvalorTerrCart(imovel.VALOR_CARTORIO_TERRENO);
    }

    if (imovel.VALOR_PREFEITURA_BENFEITORIAS) {
      setvalorBenfPref(imovel.VALOR_PREFEITURA_BENFEITORIAS);
    }

    if (imovel.VALOR_PREFEITURA_TERRENO) {
      setvalorTerrPref(imovel.VALOR_PREFEITURA_TERRENO);
    }

    if (imovel.VENC) {
      setVenc(new Date(imovel.VENC));
    } else {
      if (prefeituraIsLogged || funcionarioPrefeituraIsLogged)
        setVenc(
          new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 1,
            new Date().getDate()
          )
        );
    }

    if (imovel.ENTRADA == null) {
      setEntrada(0);
    } else {
      setEntrada(imovel.ENTRADA);
    }
  }, [imovel]);

  async function post() {
    try {
      setLoading(true);

      if (parte1 == 0 && (cartorioIsLogged || funcionarioCartorioIsLogged)) {
        setEntrada(valorBenfCart + valorTerrCart);
        setParte1(1);
        return;
      }

      if (funcionarioCartorioIsLogged) {
        await checarTokenFuncionario();
      }

      if (cartorioIsLogged) {
        await checarToken();
      }

      if (funcionarioPrefeituraIsLogged) {
        await checarTokenFuncionarioPrefeitura();
      }
      if (prefeituraIsLogged) {
        await checarTokenPrefeitura();
      }
      if (prefeituraIsLogged || funcionarioPrefeituraIsLogged)
        if (
          (valorTerrCart ? valorTerrCart : 0) +
          (valorBenfCart ? valorBenfCart : 0) <
          entrada
        ) {
          setError({
            title: "Valores inválidos",
            message:
              "Valor total do imóvel menor que o valor de entrada digitado!",
          });
          return;
        }

      if (cartorioIsLogged || funcionarioCartorioIsLogged)
        if (
          (valorTerrCart ? valorTerrCart : 0) +
          (valorBenfCart ? valorBenfCart : 0) <
          entrada
        ) {
          setError({
            title: "Valores inválidos",
            message:
              "Valor total do imóvel menor que o valor de entrada digitado!",
          });
          return;
        }

      if (!tributado) {
        if (!tipoNaoTributado.ID) {
          setError({
            title: "Razão de não tributação não selecionada",
            message: "Nenhum tipo de não tributação foi selecionado!",
          });
          return;
        }
        if (baseLegal.trim().length == 0) {
          setError({
            title: "A base legal deve ser apresentada!",
            message: "Você deve preencher o campo base legal!",
          });
          return;
        }

        const { data } = await api.patch(
          `/imovel${isRural() ? "-rural" : ""}/nao-tributado`,
          {
            ID: imovel.ID,
            NAO_TRIBUTADO: tipoNaoTributado.ID,
            OBS_NAO_TRIBUTADO: baseLegal,
          }
        );
        imovel.OBS_NAO_TRIBUTADO = baseLegal;
        imovel.TIPO_TRIBUTACAO = tipoNaoTributado.ID;
        imovel.CLASSE_NAO_TRIBUTADO = tipoNaoTributado.TITULO;
      } else {
        const { data } = await api.patch(
          `/imovel${isRural() ? "-rural" : ""}/nao-tributado`,
          {
            ID: imovel.ID,
            NAO_TRIBUTADO: null,
            OBS_NAO_TRIBUTADO: null,
          }
        );
        imovel.OBS_NAO_TRIBUTADO = undefined;
        imovel.TIPO_TRIBUTACAO = undefined;
        imovel.CLASSE_NAO_TRIBUTADO = undefined;
      }

      const { data } = await api.patch(
        `/imovel${isRural() ? "-rural" : ""}/update-valores`,
        {
          id: imovel.ID,
          ALIQUOTA: aliquota ? aliquota : 0,
          VALOR_CARTORIO_TERRENO: valorTerrCart ? valorTerrCart : 0,
          VALOR_CARTORIO_BENFEITORIAS: valorBenfCart ? valorBenfCart : 0,
          VALOR_PREFEITURA_TERRENO: valorTerrPref ? valorTerrPref : 0,
          VALOR_PREFEITURA_BENFEITORIAS: valorBenfPref ? valorBenfPref : 0,
          VENC: vencimento ? vencimento : 0,
          ALIQUOTA2: aliquota2 ? aliquota2 : 0,
          ENTRADA: entrada ? entrada : 0,
        }
      );

      if (aliquota) imovel.ALIQUOTA = aliquota;
      if (aliquota2) imovel.ALIQUOTA2 = aliquota2;
      valorTerrCart
        ? (imovel.VALOR_CARTORIO_TERRENO = valorTerrCart)
        : (imovel.VALOR_CARTORIO_TERRENO = 0);
      valorBenfCart
        ? (imovel.VALOR_CARTORIO_BENFEITORIAS = valorBenfCart)
        : (imovel.VALOR_CARTORIO_BENFEITORIAS = 0);
      imovel.VALOR_CARTORIO_BENFEITORIAS = valorBenfCart;
      valorBenfPref
        ? (imovel.VALOR_PREFEITURA_BENFEITORIAS = valorBenfPref)
        : (imovel.VALOR_PREFEITURA_BENFEITORIAS = 0);

      valorTerrPref
        ? (imovel.VALOR_PREFEITURA_TERRENO = valorTerrPref)
        : (imovel.VALOR_PREFEITURA_TERRENO = 0);

      if (entrada) imovel.ENTRADA = entrada;

      imovel.VENC = vencimento;
      handleSetImovel(imovel);
      onClose();
    } catch (error) {
      setError({
        message:
          "Não foi possível atualizar os valores, tente novamente mais tarde!",
        title: "Não foi possível atualizar os valores!",
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container style={{ maxHeight: "85vh" }}>
        {funcionarioCartorioIsLogged ||
          cartorioIsLogged ||
          !imovel.CARTORIO_ID ? (
          <>
            <SectionTitle>CARTÓRIO</SectionTitle>

            <Section disabled={prefeituraIsLogged && !!imovel.CARTORIO_ID}>
              {parte1 == 0 ? (
                <>
                  <ContainertInput>
                    <InputMoeda
                      label="VALOR TERRENO"
                      value={valorTerrCart}
                      onChange={setvalorTerrCart}
                      disabled={prefeituraIsLogged && !!imovel.CARTORIO_ID}
                      placeholder="VALOR TERRENO"
                      style={{
                        background: theme.colors.light,
                        fontSize: "max(1vw, 10px)",
                        padding: "1vh 2vw",
                        borderRadius: "0.25rem",
                        border: "1px solid #ccc",
                      }}
                    />
                  </ContainertInput>


                  <ContainertInput>
                    <InputMoeda
                      label="VALOR BENFEITORIAS"
                      value={valorBenfCart}
                      onChange={setvalorBenfCart}
                      disabled={prefeituraIsLogged && !!imovel.CARTORIO_ID}
                      placeholder="VALOR BENFEITORIAS"
                      style={{
                        background: theme.colors.light,
                        fontSize: "max(1vw, 10px)",
                        padding: "1vh 2vw",
                        borderRadius: "0.25rem",
                        border: "1px solid #ccc",
                      }}
                    />
                  </ContainertInput>

                  {(prefeituraIsLogged || funcionarioPrefeituraIsLogged) && <ContainertInput>
                    <InputMoeda
                      label="VALOR PAGO À VISTA"
                      value={entrada}
                      onChange={setEntrada}
                      disabled={prefeituraIsLogged && !!imovel.CARTORIO_ID}
                      placeholder="VALOR PAGO À VISTA"
                      style={{
                        background: theme.colors.light,
                        fontSize: "max(1vw, 10px)",
                        padding: "1vh 2vw",
                        borderRadius: "0.25rem",
                        border: "1px solid #ccc",
                      }}
                    />
                  </ContainertInput>
                  }
                </>
              ) : (
                <>
                  <ContainertInput>
                    <InputMoeda
                      label="VALOR PAGO À VISTA"
                      value={entrada}
                      onChange={setEntrada}
                      disabled={prefeituraIsLogged && !!imovel.CARTORIO_ID}
                      placeholder="VALOR PAGO À VISTA"
                      style={{
                        background: theme.colors.light,
                        fontSize: "max(1vw, 10px)",
                        padding: "1vh 2vw",
                        borderRadius: "0.25rem",
                        border: "1px solid #ccc",
                      }}
                    />
                  </ContainertInput>

                </>
              )}
            </Section>
          </>
        ) : (
          ""
        )}
        {funcionarioPrefeituraIsLogged || prefeituraIsLogged ? (
          <>
            {" "}
            <SectionTitle>FAZENDA</SectionTitle>
            <Section disabled={funcionarioCartorioIsLogged || cartorioIsLogged}>
              <ContainertInput>
                <InputMoeda
                  label="VALOR TERRENO"
                  value={valorTerrPref}
                  onChange={setvalorTerrPref}
                  disabled={funcionarioCartorioIsLogged || cartorioIsLogged}
                  placeholder="VALOR TERRENO"
                  style={{
                    background: theme.colors.light,
                    fontSize: "max(1vw, 10px)",
                    padding: "1vh 2vw",
                    borderRadius: "0.25rem",
                    border: "1px solid #ccc",
                  }}
                />
              </ContainertInput>


              <ContainertInput>
                <InputMoeda
                  label="VALOR BENFEITORIAS"
                  value={valorBenfPref}
                  onChange={setvalorBenfPref}
                  disabled={funcionarioCartorioIsLogged || cartorioIsLogged}
                  placeholder="VALOR BENFEITORIAS"
                  style={{
                    background: theme.colors.light,
                    fontSize: "max(1vw, 10px)",
                    padding: "1vh 2vw",
                    borderRadius: "0.25rem",
                    border: "1px solid #ccc",
                  }}
                />
              </ContainertInput>


              <ContainertInput
                style={{
                  cursor:
                    funcionarioCartorioIsLogged || cartorioIsLogged
                      ? "not-allowed"
                      : "auto",
                }}
              >
                <InputMoeda
                  label="Alíquota sobre o valor financiado"
                  value={aliquota}
                  onChange={setAliquota}
                  disabled={funcionarioCartorioIsLogged || cartorioIsLogged}
                  placeholder="Informe a alíquota do financiamento"
                  style={{
                    background: theme.colors.light,
                    fontSize: "max(1vw, 10px)",
                    padding: "1vh 2vw",
                    borderRadius: "0.25rem",
                    border: "1px solid #ccc",
                  }}
                />

                <InputMoeda
                  label="Alíquota sobre a entrada e valor restante da avaliação"
                  value={aliquota2}
                  onChange={setAliquota2}
                  disabled={funcionarioCartorioIsLogged || cartorioIsLogged}
                  placeholder="Informe a alíquota sobre a entrada e o valor restante da avaliação "
                  style={{
                    background: theme.colors.light,
                    fontSize: "max(1vw, 10px)",
                    padding: "1vh 2vw",
                    borderRadius: "0.25rem",
                    border: "1px solid #ccc",
                  }}
                />


                <DatePickerWrapperStyles />

                <Label
                  style={{
                    cursor:
                      funcionarioCartorioIsLogged || cartorioIsLogged
                        ? "not-allowed"
                        : "auto",
                  }}
                >
                  Vencimento
                  <DatePicker
                    minDate={new Date()}
                    value={vencimento}
                    onChange={setVenc}
                    locale="pt-br"
                    format="dd/MM/yyyy"
                    className="formata-date-picker"
                    calendarIcon={
                      <Calendar
                        size={"calc(0.4vw + 8px)"}
                        color={theme.colors.dark}
                      />
                    }
                    clearIcon={
                      <X size={"calc(0.6vw + 8px)"} color={theme.colors.dark} />
                    }
                  />
                </Label>
              </ContainertInput>

            </Section>
          </>
        ) : (
          ""
        )}
        <Section disabled={false}>
          <HelperCentralize>
            <LabelRadioButton
              onClick={() => {
                setTributado(true);
              }}
            >
              Tributado <input type={"radio"} checked={tributado} />
            </LabelRadioButton>

            <LabelRadioButton
              onClick={() => {
                setTributado(false);
              }}
            >
              Não tributado <input type={"radio"} checked={!tributado} />
            </LabelRadioButton>
          </HelperCentralize>
          <div hidden={tributado}>
            <ContainertInput>
              <HelperCentralize>
                <TipoNaoTributadoButton
                  onClick={() => setmodalTipoTributacao(true)}
                >
                  {tipoNaoTributado.ID ? tipoNaoTributado.TITULO : "TIPO"}
                  <ChevronDown
                    size={"max(1.5vw, 14px)"}
                    style={{ marginLeft: "1vw" }}
                  />
                </TipoNaoTributadoButton>
              </HelperCentralize>
            </ContainertInput>
            <ContainertInput>
              <Label>
                BASE LEGAL
                <Textarea
                  id="textarea_baseLegal"
                  rows={5}
                  maxLength={800}
                  value={baseLegal}
                  onChange={(ev) => {
                    setBaseLegal(ev.target.value);
                  }}
                >
                  {baseLegal}
                </Textarea>
              </Label>
            </ContainertInput>
          </div>
        </Section>

        <Section disabled={false}>
          <Button onClick={post}>CONFIRMAR</Button>
        </Section>
        <br /><br /><br />

        <ModalLoader loading={loading} />

        <Alert
          message={error.message}
          title={error.title}
          open={error.message.length > 0}
          onClose={() => setError({ message: "", title: "" })}
        />
      </Container>

      <ModalTipoNaoTributado
        open={modalTipoTributacao}
        onClose={() => {
          setmodalTipoTributacao(false);
        }}
        handleSetTipo={(tipo) => setTipoNaoTributado(tipo)}
        tipo_focus={tipoNaoTributado}
      />
    </Modal>
  );
}

const formatarNumero = (valor: any) => {
  return valor;
  if (!isNaN(valor)) {
    // valor = valor
    //   .toString()
    //   .replace(",", ".") // Garante que a vírgula seja substituída por ponto
    //   .replace(/[^\d.-]/g, ""); // Remove caracteres não numéricos, exceto ponto e traço
  } else {
    return "0,00";
  }
};
